module.exports = __webpack_public_path__ + "static/media/bloodthirster.5401f44b.png";